import request from '@/utils/request'

export function getList (filters, pagination) {

  //issue 242 services
  filters["response"] = "%{%"
  //issue 242 services

  return request({
    url: '/log',
    method: 'get',
    headers: {
      'X-filters': JSON.stringify(filters),
      'X-pagination': JSON.stringify(pagination)
    }
  })
}

export function getDashboardData (filters) {
  return request({
    url: '/dashboard_data',
    method: 'get',
    headers: {
      'X-filters': JSON.stringify(filters)
    }
  })
}


export function getLogRouteList (val) {
  return request({
    url: '/log/route',
    headers: {
      'X-filters': JSON.stringify({val})
    }
  })
}
